module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "callback-container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('h2', [_vm._v("Verifierar inloggning...")]), _vm._v(" "), _c('p', [_vm._v("Vänligen vänta medan vi verifierar din inloggningslänk.")])]) : (_vm.error) ? _c('div', {
    staticClass: "card error"
  }, [_c('div', {
    staticClass: "error-icon"
  }, [_vm._v("⚠️")]), _vm._v(" "), _c('h2', [_vm._v("Inloggningen misslyckades")]), _vm._v(" "), _c('p', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/logga-in?admin=1"
    }
  }, [_vm._v("Gå till inloggning")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6615020c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/AuthCallback.vue
// module id = 1005
// module chunks = 0